import { Button } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';

import { useBreakpoint } from '@/hooks/useBreakpoint';

function truncateResortName(name: string) {
  return name.replace(/\s*(&\s*)?(RV|Resort|and Campground).*?$|\s+at\s+.*$/, '').trim();
}

interface IEscapeTileeCTAProps {
  slug: string;
  name: string;
  onClick?: () => void;
}

export const EscapeTileCTA = ({ slug, name, onClick }: IEscapeTileeCTAProps) => {
  const intl = useIntl();
  const truncatedName = truncateResortName(name);
  const { isMobile } = useBreakpoint();

  return (
    <div>
      <Button
        href={slug}
        label={intl.formatMessage(
          {
            defaultMessage: 'Book {name} + RV',
            id: 'gb4t+W',
          },
          {
            name: truncatedName,
          },
        )}
        target={!isMobile ? '_blank' : undefined}
        onClick={onClick}
        className="[&>span]:line-clamp-1"
      />
    </div>
  );
};
